import { Component, forwardRef, Inject, Input } from '@angular/core';
import { BlockUI, NgBlockUI }                   from 'ng-block-ui';
import { NgbActiveModal }                       from '@ng-bootstrap/ng-bootstrap';
import { NgForm }                               from '@angular/forms';

import { CompanyService }          from '../companies/company.service';
import { InvoiceModel }            from './models/invoice';
import { InvoiceService }          from './invoice.service';
import { MessagesService }         from '../messages/messages.service';
import { MessengerService }        from '../messages/messenger/messenger.service';
import { TemplatedWordingService } from '../templates/templated-wording.service';

@Component({
  selector   : 'invoice-sms',
  template: require('./invoice.sms.component.html')
})
export class InvoiceSmsComponent {
  @BlockUI('block') block : NgBlockUI;

  @Input() invoice: InvoiceModel;
  @Input() sms    : any;

  constructor(
    public  activeModal            : NgbActiveModal,
    public companyService          : CompanyService,
    @Inject(forwardRef(() => InvoiceService))
    public invoiceService          : InvoiceService,
    private messagesService        : MessagesService,
    private messengerService       : MessengerService,
    private templatedWordingService: TemplatedWordingService
  ) {}

  addTemplates () : void {
    this.templatedWordingService.addTemplate('sms')
    .then(templates => {
      templates.forEach(template => {
        this.sms.message = this.sms.message
          ? `${ this.sms.message }\n\n${ template.wording }`
          : template.wording;
      });
    });
  }

  isPhoneNumberValid ( form : NgForm ) : boolean {
    return !form.form.controls.send_to?.errors?.phoneValidator;
  }

  send ( form : NgForm ) : void {
    this.block.start();

    this.messengerService.sendSms(this.sms)
    .then(() => {
      this.activeModal.close();
    })
    .catch(err => {
      this.messagesService.error(err);
    })
    .finally(() => {
      this.block.stop();
    });
  }
}
